// extracted by mini-css-extract-plugin
export default {"mortgageRates":"MortgageRates_mortgageRates__QF1HA"};